module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [('start' === _vm.state) ? _c('div', [_c('div', {
    attrs: {
      "id": "splash"
    },
    on: {
      "click": _vm.start
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/splash.png")
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-primary btn-block"
  }, [_vm._v("Get Started")])])]) : _vm._e(), _vm._v(" "), ('quiz' === _vm.state) ? _c('div', _vm._l((_vm.questions), function(question, index) {
    return _c('quiz-item', {
      key: index,
      attrs: {
        "question": question,
        "index": index,
        "selectedIndex": _vm.selectedIndex,
        "latest": _vm.latest,
        "length": _vm.length,
        "binding": question.binding
      },
      on: {
        "answer": _vm.answerQuestion,
        "prev": _vm.prevQuestion,
        "next": _vm.nextQuestion
      }
    })
  })) : _vm._e(), _vm._v(" "), ('result' === _vm.state) ? _c('div', [_c('result', {
    attrs: {
      "answers": _vm.answers,
      "loaded": _vm.loaded
    },
    on: {
      "restart": _vm.restartQuiz
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc235ee6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 85
// module chunks = 1